var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"block--element notification",class:_vm.statusClass},[_c('div',{staticClass:"block__wrapper"},[_c('lennoc-icon',{attrs:{"image":_vm.statusIcon}}),_c('div',{staticClass:"block__content"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.message))])])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }